/*
  cleanWhiteSpace.js
*/

/**
 * Cleans all whitespace by replacing it with single spaces.
 */
export default function cleanWhiteSpace(str) {

  if (typeof str === 'string') {
    return str.trim().replace(/\s+/g, ' ');
  }

  return '';

}
